// src/components/dashboard/CustomersWithMostPoints.js
import React from 'react';
import { TrophyIcon, StarIcon } from '@heroicons/react/24/outline'; // Example icons

const CustomersWithMostPoints = () => {
    // Mock data for customers with loyalty points
    const topCustomers = [
        { id: 1, name: 'Emily Chen', points: 7500, avatar: 'https://i.pravatar.cc/150?img=3' },
        { id: 2, name: 'David Lee', points: 6800, avatar: 'https://i.pravatar.cc/150?img=5' },
        { id: 3, name: 'Sarah Miller', points: 5900, avatar: 'https://i.pravatar.cc/150?img=8' },
        { id: 4, name: 'John Doe', points: 5200, avatar: 'https://i.pravatar.cc/150?img=12' },
        { id: 5, name: 'Maria Garcia', points: 4800, avatar: 'https://i.pravatar.cc/150?img=15' },
        { id: 6, name: 'Chris Evans', points: 4100, avatar: 'https://i.pravatar.cc/150?img=17' },
    ];

    // Sort customers by points in descending order (already sorted in mock data, but good practice)
    topCustomers.sort((a, b) => b.points - a.points);

    return (
        <div className="bg-white rounded-lg shadow-md p-6 flex flex-col overflow-hidden">
            <h3 className="text-xl font-semibold text-gray-800 mb-7 flex items-center">
                <TrophyIcon className="h-6 w-6 text-yellow-500 mr-2" /> Top Loyalty Customers
            </h3>
            <div className="flex-1 overflow-y-auto pr-2 -mr-2 max-h-80"> {/* Max height for scrollability */}
                <ul className="space-y-4">
                    {topCustomers.map((customer, index) => (
                        <li key={customer.id} className="flex items-center space-x-3 pb-2 border-b border-gray-100 last:border-b-0">
                            <span className="font-bold text-lg text-indigo-600 w-8 flex-shrink-0">{index + 1}.</span>
                            {/* Optional: Customer avatar */}
                            {customer.avatar && (
                                <img
                                    src={customer.avatar}
                                    alt={customer.name}
                                    className="h-10 w-10 rounded-full object-cover"
                                />
                            )}
                            <div className="flex-1">
                                <p className="text-gray-800 font-medium">{customer.name}</p>
                                <p className="text-sm text-gray-600">
                                    <StarIcon className="h-4 w-4 inline-block text-yellow-400 mr-1" />
                                    {customer.points.toLocaleString()} Points
                                </p>
                            </div>
                            {/* Optional: View Profile Button */}
                            {/* <button className="text-sm text-indigo-600 hover:text-indigo-800 transition-colors duration-200">
                View
              </button> */}
                        </li>
                    ))}
                </ul>
            </div>
            <p className="text-sm text-gray-500 mt-4">Identify and engage with your most loyal members.</p>
        </div>
    );
};

export default CustomersWithMostPoints;